export default __webpack_public_path__ + "static/media/img-17.e42c667e.jpeg";